<template>
<div id="clockingAnalysis" class="content">
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-12">
                    <form class="form" @submit.prevent="retriveAnalysis">
                            <div class="form-group row">
                                <div class="col-sm-2">
                                    <label class="control-label" for="created_at">{{ label.start_date }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <input type="date" class="form-control" required id="start_date" name="new_start_date" v-model="reqCrit.start_date" >
                                </div>
                                <div class="col-sm-2">
                                    <label class="control-label" for="ended_at">{{ label.end_date }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <input type="date" class="form-control" required id="end_date" name="end_date" v-model="reqCrit.end_date" >
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <span style="color: blue">Filter By </span>
                                </div>


                            </div>

                            <div class="form-group row">
                                <!--div class="col-sm-2" >
                                    <label class="control-label">{{ label.project_id }}</label>
                                </div -->
                                <div class="col-sm-3">

                                    <v-autocomplete
                                        :items="projects"
                                        v-model="projectSelection"
                                        item-text="display_name"
                                        item-value="id"
                                        label="Select Project(s)"
                                        multiple
                                        :menu-props="{maxHeight:'400'}"
                                        class="gray"
                                    ></v-autocomplete>

                                </div>
                            </div>

                            <div class="form-group row">
                                <!--div class="col-sm-2" >
                                    <label class="control-label">{{ label.reason_id }}</label>
                                </div -->
                                <div class="col-sm-3">
                                    <v-autocomplete
                                        :items="reasons"
                                        v-model="reasonSelection"
                                        item-text="display_name"
                                        item-value="id"
                                        label="Select Reason(s)"
                                        multiple
                                        :menu-props="{maxHeight:'400'}"
                                    ></v-autocomplete>
                                </div>


                            </div>

                            <div class="form-group row">
                                <!--div class="col-sm-2" >
                                    <label class="control-label">{{ label.company_id }}</label>
                                </div -->
                                <div class="col-sm-3">

                                    <v-autocomplete
                                        :items="companies"
                                        v-model="companySelection"
                                        item-text="display_name"
                                        item-value="id"
                                        label="Select Company(s)"
                                        multiple
                                        :menu-props="{
                                            maxHeight:'400',


                                            }"
                                    ></v-autocomplete>

                                </div>
                            </div>

                            <div class="form-group row">
                                <!--div class="col-sm-2" >
                                    <label class="control-label">{{ label.company_id }}</label>
                                </div -->
                                <div class="col-sm-3">

                                    <v-autocomplete
                                        :items="geolocation"
                                        v-model="geolocationSelection"
                                        item-text="location_name"
                                        item-value="id"
                                        label="Select Geofencing(s)"
                                        multiple
                                        :menu-props="{
                                            maxHeight:'400',


                                            }"
                                    ></v-autocomplete>

                                </div>
                            </div>

                            <div class="form-group row text-center">
                                <div v-if="loading" class="col-sm-11">
                                    <button type="submit" class="btn btn-default" disabled >REFRESH</button>
                                </div>
                                <div  v-else class="col-sm-11">
                                    <button type="submit" class="btn btn-primary" >REFRESH</button>
                                </div>
                            </div>
                    </form>
                </div>
            </div>
            <hr />
            <div class="row">
                <div class="col-sm-12">
                    <a href="" @click.prevent="printPDF" target="_blank"><img src="../../assets/images/print.png" alt="export to PDF" style="height: 22px; float: right; padding-left: 8px; margin-bottom: 5px;"></a>
                    <a href="" @click.prevent="getCSV"><img src="../../assets/images/download.png" style="height: 22px; float: right;"></a>

                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <v-data-table
                        :items="analysis"
                        :headers="tableHeader"
                        :pagination.sync="pagination"
                        class="elevation-1 fixed-header"
                    >
                        <template slot="items" slot-scope="">
                            <td v-for="(header, index) in tableHeader" :key="index">

                            </td>
                        </template>
                        <template slot="items" slot-scope="props">

                            <td class="justify-center layout px-0">
                                <v-icon small class="mr-2 pt-3" @click="openAddForm(props.item)">add</v-icon>
                                <v-icon small class="mr-2 pt-3" @click="openEditForm(props.item)">edit</v-icon>
                            </td>

                            <td class="text-xs-left" nowrap>
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.employee_name }}
                                </span>
                                <span v-else>{{ props.item.employee_name }}</span>
                            </td>
                            <td class="text-xs-left" nowrap>
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.company_name }}
                                </span>
                                <span v-else>
                                    {{ props.item.company_name }}
                                </span>
                            </td>
                            <td v-if="props.item.supervisor_id === props.item.employee_id" class="text-xs-left" nowrap></td>
                            <td v-if="props.item.supervisor_id !== props.item.employee_id" class="text-xs-left" nowrap>
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.supervisor_name }}
                                </span>
                                <span v-else>
                                    {{ props.item.supervisor_name }}
                                </span>
                            </td>
                            <td v-if="props.item.clock_in_at == null" class="text-xs-left"></td>
                            <td v-if="props.item.clock_in_at != null" class="text-xs-left" nowrap>
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.clock_in_at | formatUxDateTime}}
                                </span>
                                <span v-else>
                                    {{ props.item.clock_in_at | formatUxDateTime}}
                                </span>
                            </td>
                            <td v-if="props.item.clock_out_at == null" class="text-xs-left"></td>
                            <td v-if="props.item.clock_out_at != null" class="text-xs-left" nowrap>
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.clock_out_at | formatUxDateTime }}
                                </span>
                                <span v-else>
                                    {{ props.item.clock_out_at | formatUxDateTime }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.in_reason_name }}
                                </span>
                                <span v-else>
                                    {{ props.item.in_reason_name }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.in_project_name }}
                                </span>
                                <span v-else>
                                    {{ props.item.in_project_name }}
                                </span>
                            </td>
                            <td class="text-xs-left" nowrap>
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.in_location }}
                                </span>
                                <span v-else>
                                    {{ props.item.in_location }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.out_reason_name }}
                                </span>
                                <span v-else>
                                    {{ props.item.out_reason_name }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.out_project_name }}
                                </span>
                                <span v-else>
                                    {{ props.item.out_project_name }}
                                </span>
                            </td>
                            <td class="text-xs-left" nowrap>
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.out_location }}
                                </span>
                                <span v-else>
                                    {{ props.item.out_location }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.clock_in_duration_minutes }}
                                </span>
                                <span v-else>
                                    {{ props.item.clock_in_duration_minutes }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    <span v-if="props.item.adjust_clock_in">
                                        {{ props.item.adjust_clock_in | formatUxDateTime }}
                                    </span>

                                </span>
                                <span v-else>
                                    <span v-if="props.item.adjust_clock_in">
                                        {{ props.item.adjust_clock_in | formatUxDateTime }}
                                    </span>
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    <span v-if="props.item.adjust_clock_out">
                                        {{ props.item.adjust_clock_out | formatUxDateTime }}
                                    </span>
                                </span>
                                <span v-else>
                                    <span v-if="props.item.adjust_clock_out">
                                        {{ props.item.adjust_clock_out | formatUxDateTime }}
                                    </span>
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.adjust_duration }}
                                </span>
                                <span v-else>
                                    {{ props.item.adjust_duration }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.adjust_remark }}
                                </span>
                                <span v-else>
                                    {{ props.item.adjust_remark }}
                                </span>
                            </td>

                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.location_code }}
                                </span>
                                <span v-else>
                                    {{ props.item.location_code }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.location_name }}
                                </span>
                                <span v-else>
                                    {{ props.item.location_name }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.clockin_t2hr_sync_time }}
                                </span>
                                <span v-else>
                                    {{ props.item.clockin_t2hr_sync_time }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.clockin_t2hr_sync_message }}
                                </span>
                                <span v-else>
                                    {{ props.item.clockin_t2hr_sync_message }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.clockout_t2hr_sync_time }}
                                </span>
                                <span v-else>
                                    {{ props.item.clockout_t2hr_sync_time }}
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.clock_in_at == null || props.item.clock_out_at == null" class="incompleteColor">
                                    {{ props.item.clockout_t2hr_sync_message }}
                                </span>
                                <span v-else>
                                    {{ props.item.clockout_t2hr_sync_message }}
                                </span>
                            </td>

                        </template>
                        <template slot="pageText" slot-scope="props">
                        Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </div>

                    <v-dialog v-model="dialogEdit" max-width="1000px">
                        <v-card style="margin-top: 130px">
                            <v-card-title><h5 class="incompleteColor">{{ dialogTitle.edit }}</h5></v-card-title>
                            <v-card-text>
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.fullname}}</label>
                                    </div>
                                    <div class="col-sm-8">
                                        <span class="incompleteColor">{{ adjustment.employee_name }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.company}}</label>
                                    </div>
                                    <div class="col-sm-8">
                                        <span class="incompleteColor">{{ adjustment.company_name }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.clock_in}}</label>
                                    </div>
                                    <div class="col-sm-3">
                                        <span v-if="adjustment.clock_in_at != null"  class="incompleteColor">{{ adjustment.clock_in_at  | formatUx24DateTime }}</span>
                                    </div>
                                </div>
                                 <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.in_reason}}</label>
                                    </div>
                                    <div class="col-sm-2">
                                        <span class="incompleteColor">{{ adjustment.in_reason_name }}</span>
                                    </div>
                                    <div class="col-sm-2">
                                        <label class="control-label">{{ dialogLabel.in_project}}</label>
                                    </div>
                                    <div class="col-sm-2">
                                        <span class="incompleteColor">{{ adjustment.in_project_name }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.clock_out }}</label>
                                    </div>
                                    <div class="col-sm-3">
                                        <span v-if="adjustment.clock_out_at != null" class="incompleteColor">{{ adjustment.clock_out_at | formatUx24DateTime }}</span>
                                    </div>
                                </div>
                                 <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.out_reason}}</label>

                                    </div>
                                    <div class="col-sm-2">
                                        <span class="incompleteColor">{{ adjustment.out_reason_name }}</span>
                                    </div>
                                    <div class="col-sm-2">
                                        <label class="control-label">{{ dialogLabel.out_project}}</label>
                                    </div>
                                    <div class="col-sm-2">
                                        <span class="incompleteColor">{{ adjustment.out_project_name }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.duration}}</label>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="incompleteColor">{{ adjustment.clock_in_duration_minutes }}</span>
                                    </div>
                                </div>


                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.e_clock_in}}</label>
                                    </div>
                                    <div class="col-sm-9">

                                            <div class="form-group row">
                                                <div class="col-sm-4">
                                                    <input type="date" placeholder="YYYY-DD-MM" class="form-control" v-model="adjust.adjust_clock_in_date" @change="calcAdjDuration()" >
                                                </div>

                                                <div class="col-sm-4">
                                                    <input type="time" placeholder="HH:MM:SS" class="form-control" v-model="adjust.adjust_clock_in_time" @change="calcAdjDuration()" >
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-sm-4">
                                                    <label class="control-label">{{ dialogLabel.e_reason_in}}</label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <select class="form-control" v-model="adjust.adjust_reason_in">
                                                        <option v-for="(reason, index) in reasons" :key="index" v-bind:value="reason.id">{{ reason.display_name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-sm-4">
                                                    <label class="control-label">{{ dialogLabel.e_project_in}}</label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <select class="form-control" v-model="adjust.adjust_project_in">
                                                        <option v-for="(project, index) in projects" :key="index" v-bind:value="project.id">{{ project.display_name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.e_clock_out}}</label>
                                    </div>
                                    <div class="col-sm-9">

                                            <div class="form-group row">
                                                <div class="col-sm-4">
                                                    <input type="date" placeholder="YYYY-DD-MM" class="form-control" v-model="adjust.adjust_clock_out_date" @change="calcAdjDuration()" >
                                                </div>

                                                <div class="col-sm-4">
                                                    <input type="time" placeholder="HH:MM:SS" class="form-control" v-model="adjust.adjust_clock_out_time" @change="calcAdjDuration()">
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-sm-4">
                                                    <label class="control-label">{{ dialogLabel.e_reason_out}}</label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <select class="form-control" v-model="adjust.adjust_reason_out">
                                                        <option v-for="(reason, index) in reasons" :key="index" v-bind:value="reason.id">{{ reason.display_name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-sm-4">
                                                    <label class="control-label">{{ dialogLabel.e_project_out}}</label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <select class="form-control" v-model="adjust.adjust_project_out">
                                                        <option v-for="(project, index) in projects" :key="index" v-bind:value="project.id">{{ project.display_name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                    </div>
                                </div>

                                <div class="form-group">
                                    <span v-if="this.errormsg" align="center"><p class="text-danger">Validation error: {{ errormsg }}</p></span>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.e_duration}}</label>
                                    </div>
                                    <div class="col-sm-4">
                                        <input type="number" class="form-control" v-model="adjustment.adjust_duration" disabled >
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.e_remark}}</label>
                                    </div>
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control" v-model="adjustment.adjust_remark" >
                                    </div>
                                </div>
                            </v-card-text>

                            <v-card-actions>
                                <v-btn @click="updateAdjustment(adjustment.id)">SAVE</v-btn>
                                <v-btn @click="dialogEdit = false">CANCEL</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="dialogNew" max-width="1000px">
                        <v-card  style="margin-top: 60px">
                            <v-card-title><h5 class="incompleteColor">{{ dialogTitle.add }}</h5></v-card-title>
                            <v-card-text>
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.fullname}}</label>
                                    </div>
                                    <div class="col-sm-8">
                                        <span class="incompleteColor">{{ newAdjustment.employee_name }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.company}}</label>
                                    </div>
                                    <div class="col-sm-8">
                                        <span class="incompleteColor">{{ newAdjustment.company_name }}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-9">

                                        <div class="form-group row">
                                            <div class="col-sm-4">
                                                <label class="control-label">{{ dialogLabel.e_clock_in}}</label>
                                            </div>
                                            <div class="col-sm-4">
                                                <input type="date" class="form-control" v-model="newAdjustment.adjust_clock_in_date" @change="newCalcAdjDuration()" >
                                            </div>
                                            <div class="col-sm-4">
                                                <input type="time" class="form-control" v-model="newAdjustment.adjust_clock_in_time" @change="newCalcAdjDuration()" >
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-sm-4">
                                                <label class="control-label">{{ dialogLabel.e_reason_in}}</label>
                                            </div>
                                            <div class="col-sm-4">
                                                <select class="form-control" v-model="newAdjustment.adjust_reason_in">
                                                    <option v-for="(reason, index) in reasons" :key="index" v-bind:value="reason.id">{{ reason.display_name }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-sm-4">
                                                <label class="control-label">{{ dialogLabel.e_project_in}}</label>
                                            </div>
                                            <div class="col-sm-4">
                                                <select class="form-control" v-model="newAdjustment.adjust_project_in">
                                                    <option v-for="(project, index) in projects" :key="index" v-bind:value="project.id">{{ project.display_name }}</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-9">
                                        <div class="form-group row">
                                            <div class="col-sm-4">
                                                <label class="control-label">{{ dialogLabel.e_clock_out}}</label>
                                            </div>
                                            <div class="col-sm-4">
                                                <input type="date" class="form-control" v-model="newAdjustment.adjust_clock_out_date" @change="newCalcAdjDuration()" >
                                            </div>
                                            <div class="col-sm-4">
                                                <input type="time" class="form-control" v-model="newAdjustment.adjust_clock_out_time" @change="newCalcAdjDuration()" >
                                            </div>
                                        </div>

                                    <div class="form-group row">
                                            <div class="col-sm-4">
                                                <label class="control-label">{{ dialogLabel.e_reason_out}}</label>
                                            </div>
                                            <div class="col-sm-4">
                                                <select class="form-control" v-model="newAdjustment.adjust_reason_out">
                                                    <option v-for="(reason, index) in reasons" :key="index" v-bind:value="reason.id">{{ reason.display_name }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-sm-4">
                                                <label class="control-label">{{ dialogLabel.e_project_out}}</label>
                                            </div>
                                            <div class="col-sm-4">
                                                <select class="form-control" v-model="newAdjustment.adjust_project_out">
                                                    <option v-for="(project, index) in projects" :key="index" v-bind:value="project.id">{{ project.display_name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <span v-if="this.errormsg" align="center"><p class="text-danger">{{ errormsg }}</p></span>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.e_duration}}</label>
                                    </div>
                                    <div class="col-sm-4">
                                        <input type="number" class="form-control" v-model="newAdjustment.adjust_duration" disabled >
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="control-label">{{ dialogLabel.e_remark}}</label>
                                    </div>
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control" v-model="newAdjustment.adjust_remark" >
                                    </div>
                                </div>
                            </v-card-text>

                            <v-card-actions>
                                <v-btn @click="addAdjustment">SAVE</v-btn>
                                <v-btn @click="dialogNew = false">CANCEL</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

            </div>
</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import ReasonSelectDialog from '../shared/ReasonSelectDialog'

import { formatUXDateTime, formatUX24DateTime, formatUXDate, formatUXTime, formatUX24Time } from '../common/toggle.js'
import { isNull } from 'util'

export default {
    components: {
        'reason-select-dialog': ReasonSelectDialog
    },

    data () {
        return {
            title: 'CLOCKING ANALYSIS',

            label: {
                start_date: 'Records From',
                end_date: 'Records To',
                project_id: 'Project',
                reason_id: 'Reason',
                company_id: 'Company',
                geolocation_id: 'Geofencing',
            },
            reqCrit: {
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                project_id: '',
                reason_id: '',
                company_id: '',
                geolocation_id: '',
            },
            reasonSelection: [],
            projectSelection: [],
            companySelection: [],
            geolocationSelection: [],
            projects: [],
            reasons: [],
            companies: [],
            geolocation: [],
            analysis: [],
            tableHeader: [
                { text: 'ACTION', sortable: false, value: 'action' },
                { text: 'FULL NAME', sortable: true, value: 'employee_name' },
                { text: 'COMPANY', sortable: true, value: 'company_name' },
                { text: 'MANAGED BY', sortable: true, value: 'supervisor_name' },
                { text: 'CLOCK IN DATE/TIME', sortable: true, value: 'clock_in_at' },
                { text: 'CLOCK OUT DATE/TIME', sortable: true, value: 'clock_out_at' },
                { text: 'IN REASON', sortable: true, value: 'in_reason_name' },
                { text: 'IN PROJECT', sortable: true, value: 'in_project_name' },
                { text: 'IN LOCATION', sortable: false, value: 'in_location' },
                { text: 'OUT REASON', sortable: true, value: 'out_reason_name' },
                { text: 'OUT PROJECT', sortable: true, value: 'out_project_name' },
                { text: 'OUT LOCATION', sortable: false, value: 'out_location' },
                { text: 'DURATION (HRS)', sortable: false, value: 'clock_in_duration_minutes' },
                { text: 'ADJUSTED CLOCK IN DATE/TIME', sortable: false, value: 'adjust_clock_in' },
                { text: 'ADJUSTED CLOCK OUT DATE/TIME', sortable: false, value: 'adjust_clock_out' },
                { text: 'ADJUSTED DURATION', sortable: false, value: 'adjust_duration' },
                { text: 'ADJUSTMENT REMARKS', sortable: false, value: 'adjust_remark' },
                { text: 'GEOLOCATION NAME', sortable: false, value: 'location_name' },
                { text: 'GEOLOCATION CODE', sortable: false, value: 'location_code' },
                { text: 'CLOCK IN T2HR SYNC TIME', sortable: false, value: 'clockin_t2hr_sync_time' },
                { text: 'CLOCK OUT T2HR SYNC TIME', sortable: false, value: 'clockout_t2hr_sync_time' },
                { text: 'CLOCK IN T2HR SYNC MESSAGE', sortable: false, value: 'clockin_t2hr_sync_message' },
                { text: 'CLOCK OUT T2HR SYNC MESSAGE', sortable: false, value: 'clockout_t2hr_sync_message' }
            ],
            status: '',
            dialogEdit: false,
            dialogNew: false,
            dialogTitle: {edit: 'EDIT Clocking Record', add: 'ADD Clocking Record'},
            dialogLabel: {
                fullname: 'Full Name',
                company: 'Company',
                clock_in: 'Clock IN Date and Time',
                clock_out: 'Clock OUT Date and Time',
                duration: 'Duration',
                in_reason: 'IN Reason',
                in_project: 'IN Project',
                out_reason: 'OUT Reason',
                out_project: 'OUT Project',
                e_clock_in: 'EDITED Clock IN Date and Time',
                e_clock_out: 'EDITED Clock OUT Date and Time',
                e_duration: 'EDITED Duration (hrs)',
                e_reason_in: 'EDITED IN Reason',
                e_project_in: 'EDITED IN Project',
                e_reason_out: 'EDITED OUT Reason',
                e_project_out: 'EDITED OUT Project',
                e_remark: 'Adjustment Remarks'
            },
            adjustment: [],
            adjust: {
                adjust_clock_in_date: '',
                adjust_clock_in_time: '',
                adjust_clock_out_date: '',
                adjust_clock_out_time: '',

                adjust_reason_in: '',
                adjust_project_in: '',
                adjust_reason_out: '',
                adjust_project_out: '',
            },
            newAdjustment: {
                employee_id: null,
                employee_name: null,
                company_name: null,
                adjust_clock_in_date: moment().format('YYYY-MM-DD'),
                adjust_clock_in_time: moment().format('HH:mm:ss'),
                adjust_clock_out_date: moment().format('YYYY-MM-DD'),
                adjust_clock_out_time: moment().format('HH:mm:ss'),
                adjust_clock_in: '',
                adjust_clock_out: '',
                adjust_duration: 0,
                adjust_reason_in: null,
                adjust_project_in: null,
                adjust_reason_out: null,
                adjust_project_out: null,
                adjust_remark: null

            },
            errormsg: null,
            pagination: {'sortBy': 'clock_in_at', 'sortBy': 'clock_out_at',
                'descending': true, 'rowPerPage': -1},
            loading: false
        }
    },

    methods: {
        retriveAnalysis() {
            let vm = this

            var payload = {
                start_date: this.reqCrit.start_date,
                end_date: this.reqCrit.end_date,
                reason_id: this.reasonSelection,
                project_id: this.projectSelection,
                company_id: this.companySelection,
                geolocation_id: this.geolocationSelection
            }

            this.loading = !this.loading;

            axios.post(this.$store.getters.rootAPI + '/analysis/list', payload)
            .then(function (response) {
                if (response.status !== 401) {
                    vm.analysis = response.data.rec;

                    for (let i = 0; i < vm.analysis.length; i++) {
                        if (!vm.analysis[i].clock_in_at) vm.analysis[i].clock_in_at = null;

                        if (!vm.analysis[i].clock_in_out) vm.analysis[i].clock_in_out = null;

                        if (!vm.analysis[i].in_location) vm.analysis[i].in_location = null;

                        if (!vm.analysis[i].out_location) vm.analysis[i].out_location = null;

                        if (!vm.analysis[i].adjust_remark) vm.analysis[i].adjust_remark = null;

                        if (vm.analysis[i].clock_in_duration_minutes) {
                            vm.analysis[i].clock_in_duration_minutes = vm.analysis[i].clock_in_duration_minutes.toFixed(2)
                        }

                        if (vm.analysis[i].clockin_t2hr_sync_time) {
                            vm.analysis[i].clockin_t2hr_sync_time = new Date(vm.analysis[i].clockin_t2hr_sync_time).toLocaleString();
                        }

                        if (vm.analysis[i].clockout_t2hr_sync_time) {
                            vm.analysis[i].clockout_t2hr_sync_time = new Date(vm.analysis[i].clockout_t2hr_sync_time).toLocaleString();
                        }
                    }

                    vm.loading = !vm.loading;
                }

                //console.log(vm.analysis);
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveProjects() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/projects/list')
            .then(function (response) {
                vm.projects = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveReasons() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/reason/list')
            .then(function (response) {
                vm.reasons = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveCompanies() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/company/list')
            .then(function (response) {
                vm.companies = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        
        retriveGeolocation() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/geolocation/list')
            .then(function (response) {
                vm.geolocation = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        openEditForm(item) {
            var moment = require('moment')
            this.analysisIndex = this.analysis.indexOf(item)
            this.adjustment = Object.assign({}, item)

            this.errormsg = null

            var loadDelta = 0
            var load_adj_clock_in = null
            var load_adj_clock_out = null

            this.dialogEdit = true

            /*
            This part here is complicated because it can be 1 empty or both empty.
            this.adjustment comes from items.

            If this.adjustment.adjust_clock_in is NULL then
            don't do anything. Else format it and populate form field with this.adjust.clock_in_date.
            */

           if (!this.adjustment.adjust_clock_in) {
               // if adjustment.clock_it_at format it
               if (this.adjustment.clock_in_at) {
                    this.adjust.adjust_clock_in_date = formatUXDate(this.adjustment.clock_in_at)
                    this.adjust.adjust_clock_in_time = formatUX24Time(this.adjustment.clock_in_at)

                    this.adjust.adjust_reason_in = this.adjustment.in_reason_id
                    this.adjust.adjust_project_in = this.adjustment.in_project_id

                    load_adj_clock_in =formatUX24DateTime(this.adjustment.clock_in_at)

               } else {
                   // set adjust_clock_in_date time as today's date
                    this.adjust.adjust_clock_in_date = moment().format('YYYY-MM-DD')
                    this.adjust.adjust_clock_in_time = moment().format('HH:mm:ss')

                    let currentDate = moment().format('YYYY-MM-DD HH:mm:ss')
                    load_adj_clock_in = currentDate
               }
           } else {
               this.adjust.adjust_clock_in_date = formatUXDate(this.adjustment.adjust_clock_in)
               this.adjust.adjust_clock_in_time = formatUX24Time(this.adjustment.adjust_clock_in)

               this.adjust.adjust_reason_in = this.adjustment.adjust_reason_in
               this.adjust.adjust_project_in = this.adjustment.adjust_project_in

               load_adj_clock_in = formatUX24DateTime(this.adjustment.adjust_clock_in)
           }

           if (!this.adjustment.adjust_clock_out) {
               if (this.adjustment.clock_out_at) {
                    this.adjust.adjust_clock_out_date = formatUXDate(this.adjustment.clock_out_at)
                    this.adjust.adjust_clock_out_time = formatUX24Time(this.adjustment.clock_out_at)

                    this.adjust.adjust_reason_out = this.adjustment.out_reason_id
                    this.adjust.adjust_project_out = this.adjustment.out_project_id

                    load_adj_clock_out = formatUX24DateTime(this.adjustment.clock_out_at)
               } else {
                    this.adjust.adjust_clock_out_date = moment().format('YYYY-MM-DD')
                    this.adjust.adjust_clock_out_time = moment().format('HH:mm:ss')

                    let currentDate = moment().format('YYYY-MM-DD HH:mm:ss')
                    load_adj_clock_out = currentDate
               }
           } else {
               this.adjust.adjust_clock_out_date = formatUXDate(this.adjustment.adjust_clock_out)
               this.adjust.adjust_clock_out_time = formatUX24Time(this.adjustment.adjust_clock_out)

               this.adjust.adjust_reason_out = this.adjustment.adjust_reason_out
               this.adjust.adjust_project_out = this.adjustment.adjust_project_out

               load_adj_clock_out = formatUX24DateTime(this.adjustment.adjust_clock_out)
           }

           load_adj_clock_out = moment(load_adj_clock_out)
           load_adj_clock_in = moment(load_adj_clock_in)

           loadDelta = load_adj_clock_out.diff(load_adj_clock_in, 'hours', true)

           this.adjustment.adjust_duration = loadDelta.toFixed(2);

           this.adjustment.adjust_clock_out = this.adjust.adjust_clock_out_date + ' ' + this.adjust.adjust_clock_out_time
           this.adjustment.adjust_clock_in = this.adjust.adjust_clock_in_date + ' ' + this.adjust.adjust_clock_in_time

           // convert back to unix format
           this.adjustment.adjust_clock_out = moment(this.adjustment.adjust_clock_out).unix()
           this.adjustment.adjust_clock_in = moment(this.adjustment.adjust_clock_in).unix()
        },

        openAddForm(item){
            this.newAdjustment.employee_id = item.employee_id
            this.newAdjustment.employee_name = item.employee_name
            this.newAdjustment.company_name = item.company_name
            this.dialogNew = true
        },

        calcAdjDuration() {
            this.adjustment.adjust_clock_out = this.adjust.adjust_clock_out_date + ' ' + this.adjust.adjust_clock_out_time
            this.adjustment.adjust_clock_in = this.adjust.adjust_clock_in_date + ' ' + this.adjust.adjust_clock_in_time

            var adj_clock_out = moment(this.adjustment.adjust_clock_out)
            var adj_clock_in = moment(this.adjustment.adjust_clock_in)

            var delta = adj_clock_out.diff(adj_clock_in, 'hours', true);

            this.adjustment.adjust_duration = delta.toFixed(2);

            // convert back to unix format
            this.adjustment.adjust_clock_out = moment(this.adjustment.adjust_clock_out).unix()
            this.adjustment.adjust_clock_in = moment(this.adjustment.adjust_clock_in).unix()
        },

        newCalcAdjDuration() {
            this.newAdjustment.adjust_clock_in = this.newAdjustment.adjust_clock_in_date + ' ' + this.newAdjustment.adjust_clock_in_time
            this.newAdjustment.adjust_clock_out = this.newAdjustment.adjust_clock_out_date + ' ' + this.newAdjustment.adjust_clock_out_time

            var adj_clock_out = moment(this.newAdjustment.adjust_clock_out)
            var adj_clock_in = moment(this.newAdjustment.adjust_clock_in)

            var delta = adj_clock_out.diff(adj_clock_in, 'hours', true);

            this.newAdjustment.adjust_duration = delta.toFixed(2);
        },

        updateAdjustment(id) {
            //console.log(this.adjustment.adjust_clock_in, ' ', this.adjustment.adjust_clock_out)
            var elements = {}

            if (this.adjustment.adjust_clock_in && this.adjustment.adjust_clock_out) {
                if (this.adjustment.adjust_clock_in == this.adjustment.adjust_clock_out || this.adjustment.adjust_clock_in > this.adjustment.adjust_clock_out) {
                    this.errormsg = 'Clock IN cannot be the same or later than Clock OUT'
                } else {
                    var clkInOut = {
                        adjust_clock_in : formatUX24DateTime(this.adjustment.adjust_clock_in),
                        adjust_clock_out : formatUX24DateTime(this.adjustment.adjust_clock_out),
                        //adjust_clock_in : this.adjustment.adjust_clock_in,
                        //adjust_clock_out : this.adjustment.adjust_clock_out,
                        adjust_duration: this.adjustment.adjust_duration
                        }

                    elements = Object.assign(elements, clkInOut)

                    //this.postUpdate(id, payload);
                }
            }

            if (this.adjustment.adjust_reason_in) {
                var adjRsnIn = {adjust_reason_in: this.adjustment.adjust_reason_in}
                elements = Object.assign(elements, adjRsnIn)

                //this.postUpdate(id, payload);
            }

            if (this.adjust.adjust_reason_in) {
                var adjRsnIn = {adjust_reason_in: this.adjust.adjust_reason_in}
                elements = Object.assign(elements, adjRsnIn)

                //this.postUpdate(id, payload);
            }

            if (this.adjustment.adjust_project_in) {
                var adjPrjIn = {adjust_project_in: this.adjustment.adjust_project_in}
                elements = Object.assign(elements, adjPrjIn)

                //this.postUpdate(id, payload);
            }

            if (this.adjust.adjust_project_in) {
                var adjPrjIn = {adjust_project_in: this.adjust.adjust_project_in}
                elements = Object.assign(elements, adjPrjIn)

                //this.postUpdate(id, payload);
            }

            if (this.adjustment.adjust_reason_out) {
                var adjRsnOut = {adjust_reason_out: this.adjustment.adjust_reason_out}
                elements = Object.assign(elements, adjRsnOut)

                //this.postUpdate(id, payload);
            }

            if (this.adjust.adjust_reason_out) {
                var adjRsnOut = {adjust_reason_out: this.adjust.adjust_reason_out}
                elements = Object.assign(elements, adjRsnOut)

                //this.postUpdate(id, payload);
            }

            if (this.adjustment.adjust_project_out) {
                var adjPrjOut = {adjust_project_out: this.adjustment.adjust_project_out}
                elements = Object.assign(elements, adjPrjOut)

                //this.postUpdate(id, payload);
            }

            if (this.adjust.adjust_project_out) {
                var adjPrjOut = {adjust_project_out: this.adjust.adjust_project_out}
                elements = Object.assign(elements, adjPrjOut)

                //this.postUpdate(id, payload);
            }


            if (this.adjustment.adjust_remark) {
                var adjRemark = {adjust_remark: this.adjustment.adjust_remark}
                elements = Object.assign(elements, adjRemark)

                //this.postUpdate(id, payload);
            }

           this.postUpdate(id, elements);
        },

        postUpdate(id, payload) {
            var vm = this

            axios.put(this.$store.getters.rootAPI + '/analysis/update/' + id, payload)
            .then(function(response) {
                vm.status = response.data.status

                if(vm.status === 'success') {
                    vm.errormsg = null
                    vm.retriveAnalysis()
                    vm.dialogEdit = false
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    vm.errormsg = 'Validation error. ' + vm.validationMsg
                }
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    vm.errormsg = 'An error occured. ' + vm.status

                }
            })
        },

        addAdjustment() {
            var vm = this

            this.newAdjustment.adjust_clock_in = this.newAdjustment.adjust_clock_in_date + ' ' + this.newAdjustment.adjust_clock_in_time
            this.newAdjustment.adjust_clock_out = this.newAdjustment.adjust_clock_out_date + ' ' + this.newAdjustment.adjust_clock_out_time

            if (this.newAdjustment.adjust_clock_in == this.newAdjustment.adjust_clock_out || this.newAdjustment.adjust_clock_in > this.newAdjustment.adjust_clock_out) {
                this.errormsg = 'Clock IN cannot be the same or later than Clock OUT'
            } else {
                var payload = {
                    employee_id : vm.newAdjustment.employee_id,
                    adjust_clock_in : vm.newAdjustment.adjust_clock_in,
                    adjust_clock_out : vm.newAdjustment.adjust_clock_out,
                    adjust_duration: vm.newAdjustment.adjust_duration,
                    adjust_reason_in: vm.newAdjustment.adjust_reason_in,
                    adjust_project_in: vm.newAdjustment.adjust_project_in,
                    adjust_reason_out: vm.newAdjustment.adjust_reason_out,
                    adjust_project_out: vm.newAdjustment.adjust_project_out,
                    adjust_remark: vm.newAdjustment.adjust_remark
                }

                axios.post(this.$store.getters.rootAPI + '/analysis/add', payload)
                .then(function (response) {
                    vm.status = response.data.status

                    if(vm.status === 'success') {
                        vm.errormsg = null
                        vm.retriveAnalysis()
                        //vm.projectForm = !vm.projectForm
                        vm.dialogNew = false
                    }

                    if(response.data.errors.length > 0)
                    {
                        vm.validationMsg = response.data.errors[0].msg
                        vm.errormsg = 'Validation error. ' + vm.validationMsg
                    }
                })
                .catch(function (error) {
                    if(error.response) {
                        vm.status = error.response.data
                        alert('An error occured. ' + vm.status)
                    }
                })
            }

        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.analysis
            let data = []

            for (var i = 0; i < item.length; i++) {
                var in_dateTime = '', out_dateTime = '',
                    adjust_in_dateTime = '', adjust_out_dateTime,
                    adjustRemark = '', inLocation = '', outLocation = '',
                    adjustInReason = '', adjustInProject = '',
                    adjustOutReason = '', adjustOutProject = '';
                var duration = 0, adjust_duration = 0;

                if (item[i].clock_in_at) {
                    in_dateTime = formatUXDateTime(item[i].clock_in_at)
                } else {
                    in_dateTime = ''
                }

                if (item[i].clock_out_at) {
                    out_dateTime = formatUXDateTime(item[i].clock_out_at)
                } else {
                    out_dateTime = ''
                }

                if (item[i].clock_in_duration_minutes) {
                    duration = item[i].clock_in_duration_minutes
                } else {
                    duration = 0
                }

                if (item[i].adjust_clock_in) {
                    adjust_in_dateTime = formatUXDateTime(item[i].adjust_clock_in)
                } else {
                    adjust_in_dateTime = ''
                }

                if (item[i].adjust_clock_out) {
                    adjust_out_dateTime = formatUXDateTime(item[i].adjust_clock_out)
                } else {
                    adjust_out_dateTime = ''
                }

                if (item[i].adjust_duration && !isNull(item[i].adjust_duration)) {
                    adjust_duration = item[i].adjust_duration
                } else {
                    adjust_duration = 0
                }

                if (item[i].adjust_remark && !isNull(item[i].adjust_remark)) {
                    adjustRemark = item[i].adjust_remark
                } else {
                    adjustRemark = ''
                }

                if (item[i].in_location && !isNull(item[i].in_location)) {
                    inLocation = item[i].in_location
                } else {
                    inLocation = ''
                }

                if (item[i].out_location && !isNull(item[i].out_location)) {
                    outLocation = item[i].out_location
                } else {
                    outLocation = ''
                }

                if (item[i].adjust_in_reason_name) {
                    adjustInReason = item[i].adjust_in_reason_name
                } else {
                    adjustInReason = ''
                }

                if (item[i].adjust_in_project_name) {
                    adjustInProject = item[i].adjust_in_project_name
                } else {
                    adjustInProject = ''
                }

                if (item[i].adjust_out_reason_name) {
                    adjustOutReason = item[i].adjust_out_reason_name
                } else {
                    adjustOutReason = ''
                }

                if (item[i].adjust_out_project_name) {
                    adjustOutProject = item[i].adjust_out_project_name
                } else {
                    adjustOutProject = ''
                }

                data.push({
                    employee_name: item[i].employee_name,
                    company_name: item[i].company_name,
                    supervisor_name: item[i].supervisor_name,
                    clock_in_at: in_dateTime,
                    clock_out_at: out_dateTime,
                    clock_in_duration_hours: duration,
                    in_reason_name: item[i].in_reason_name,
                    in_project_name: item[i].in_project_name,
                    in_location: inLocation,
                    out_reason_name: item[i].out_reason_name,
                    out_project_name: item[i].out_project_name,
                    out_location: outLocation,
                    adjust_clock_in: adjust_in_dateTime,
                    adjust_clock_out: adjust_out_dateTime,
                    adjust_duration_hours: adjust_duration,
                    adjust_remark: adjustRemark,
                    edit_reason_in: adjustInReason,
                    edit_project_in: adjustInProject,
                    edit_reason_out: adjustOutReason,
                    edit_project_out: adjustOutProject
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape',
                format: 'a3'
            })
            let item = this.analysis

            var head = [
                { title: 'FULL NAME', dataKey: 'employee_name' },
                { title: 'COMPANY', dataKey: 'company_name' },
                { title: 'MANAGED BY', dataKey: 'supervisor_name' },
                { title: 'CLOCK IN DATE/TIME', dataKey: 'clock_in_at' },
                { title: 'CLOCK OUT DATE/TIME', dataKey: 'clock_out_at' },
                { title: 'DURATION (HRS)', dataKey: 'clock_in_duration_hours' },
                { title: 'IN REASON', dataKey: 'in_reason_name' },
                { title: 'IN PROJECT', dataKey: 'in_project_name' },
                { title: 'IN LOCATION', dataKey: 'in_location' },
                { title: 'OUT REASON', dataKey: 'out_reason_name' },
                { title: 'OUT PROJECT', dataKey: 'out_project_name' },
                { title: 'OUT LOCATION', dataKey: 'out_location' },
                { title: 'ADJUSTED IN DATE/TIME', dataKey: 'adjust_clock_in' },
                { title: 'ADJUSTED OUT DATE/TIME', dataKey: 'adjust_clock_out' },
                { title: 'ADJUSTED DURATION', dataKey: 'adjust_duration' },
                { title: 'ADJUSTMENT REMARKS', dataKey: 'adjust_remark' },
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {

                var in_dateTime, out_dateTime, adjust_in_dateTime, adjust_out_dateTime, adjustRemark, inLocation, outLocation, adjustReason, adjustProject;
                var duration, adjust_duration;

                if (item[i].clock_in_at) {
                    in_dateTime = formatUXDateTime(item[i].clock_in_at)
                } else {
                    in_dateTime = ''
                }

                if (item[i].clock_out_at) {
                    out_dateTime = formatUXDateTime(item[i].clock_out_at)
                } else {
                    out_dateTime = ''
                }

                if (item[i].adjust_clock_in) {
                    adjust_in_dateTime = formatUXDateTime(item[i].adjust_clock_in)
                } else {
                    adjust_in_dateTime = ''
                }

                if (item[i].adjust_clock_out) {
                    adjust_out_dateTime = formatUXDateTime(item[i].adjust_clock_out)
                } else {
                    adjust_out_dateTime = ''
                }

                if (item[i].clock_in_duration_minutes) {
                    duration = item[i].clock_in_duration_minutes
                } else {
                    duration = 0
                }

                if (item[i].adjust_duration) {
                    adjust_duration = item[i].adjust_duration
                } else {
                    adjust_duration = 0
                }

                if (!item[i].adjust_remark || typeof undefined) {
                    adjustRemark = ''
                } else {
                    adjustRemark = item[i].adjust_remark
                }

                if (item[i].in_location) {
                    inLocation = item[i].in_location
                } else {
                    inLocation = ''
                }

                if (item[i].out_location) {
                    outLocation = item[i].out_location
                } else {
                    outLocation = ''
                }

                if (item[i].adjust_reason) {
                    adjustReason = item[i].adjust_reason
                } else {
                    adjustReason = ''
                }

                if (!item[i].adjust_reason || typeof undefined) {
                    adjustReason = ''
                }

                if (!item[i].adjust_project || typeof undefined) {
                    adjustProject = ''
                } else {
                    adjustProject = item[i].adjust_project
                }

                body.push({
                    employee_name: item[i].employee_name,
                    company_name: item[i].company_name,
                    supervisor_name: item[i].supervisor_name,
                    clock_in_at: in_dateTime,
                    clock_out_at: out_dateTime,
                    clock_in_duration_hours: duration,
                    in_reason_name: item[i].in_reason_name,
                    in_project_name: item[i].in_project_name,
                    in_location: inLocation,
                    out_reason_name: item[i].out_reason_name,
                    out_project_name: item[i].out_project_name,
                    out_location: outLocation,
                    adjust_clock_in: adjust_in_dateTime,
                    adjust_clock_out: adjust_out_dateTime,
                    adjust_duration: adjust_duration,
                    adjust_remark: adjustRemark,
                    edit_reason: adjustReason,
                    edit_project: adjustProject
                })
            }

            doc.text(this.title, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.title + '.pdf')
        }
    },

    created() {
        this.retriveProjects();
        this.retriveReasons();
        this.retriveCompanies();
        this.retriveGeolocation();
    }
}
</script>

<style lang="stylus">
    @import '~vuetify-stylus-fixed-table-header';

    .fixed-header {
        fixed-table-header(35vh)
    }
</style>



// WEBPACK FOOTER //
// src/components/analysis/ClockingAnalysis.vue